var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0398 8.86944C22.262 7.73705 21.3359 6.71395 20.2864 5.82749L23.1182 2.99665C23.69 2.39123 23.6628 1.43688 23.0574 0.865055C22.4757 0.315568 21.566 0.316228 20.9851 0.866515L17.722 4.13059C15.9456 3.24296 13.9847 2.78762 11.999 2.80162C7.53392 2.84436 3.38772 5.12298 0.958174 8.86944C-0.319391 10.7484 -0.319391 13.2171 0.958174 15.0961C1.73601 16.2284 2.66205 17.2515 3.71159 18.138L0.879763 20.9718C0.290694 21.5609 0.290694 22.5159 0.879763 23.105C1.46883 23.694 2.4239 23.694 3.01292 23.105L6.276 19.8409C8.05235 20.7285 10.0133 21.1839 11.999 21.1699C16.4641 21.1272 20.6102 18.8486 23.0398 15.1021C24.3201 13.2218 24.3201 10.7497 23.0398 8.86944ZM3.44521 13.3931C2.86632 12.5442 2.86632 11.4273 3.44521 10.5784C5.29889 7.63753 8.52272 5.84318 11.999 5.81746C13.1705 5.81175 14.3335 6.01607 15.433 6.42061L13.5692 8.28338C11.525 7.41559 9.16438 8.36929 8.29663 10.4135C7.87037 11.4176 7.87037 12.5519 8.29663 13.556L5.84682 16.0068C4.92262 15.2578 4.11349 14.3772 3.44521 13.3931ZM20.5528 13.3931C18.699 16.334 15.4752 18.1283 11.999 18.1541C10.8275 18.1598 9.66443 17.9555 8.56499 17.5509L10.4287 15.6872C12.4729 16.5549 14.8336 15.6012 15.7013 13.5571C16.1276 12.5529 16.1276 11.4187 15.7013 10.4146L18.1512 7.96475C19.0753 8.71375 19.8844 9.59436 20.5527 10.5784C21.1317 11.4273 21.1317 12.5442 20.5528 13.3931Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eye_crossed.d80d40d4b156954fb6c6e8111eb59d36.svg";
export { ForwardRef as ReactComponent };